import React, { useState } from 'react';
import ThreeDotIcon from '../../../../Elements/ids/ThreeDotIcon';
import MenuList from '../../../../Elements/MenuList';
import MenuListItem from '../../../../Elements/MenuListItem';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { setAgentConversionsState, isConversionActive } from './Functions';
import { ServiceClient } from '../../../../Services/ServiceClient';

const ConversionTableMenu = ({ conversion, setAgentConversions, agentConversions, setNotifications }) => {
  const [isOpen, setIsOpen] = useState(false);

  function disableConversion() {
    ServiceClient.disableAgentCodeConversionForRenewal(
      conversion.oldCode,
      () => {
        setAgentConversionsState(conversion, agentConversions, setAgentConversions);
        setNotifications(prev => [
          ...prev,
          {
            type: 'disabled',
            message: formatMessage(Messages.agentConversionPage_mappingDisabledNotification, {
              oldCode: conversion.oldCode,
              newCode: conversion.newCode,
            }),
          },
        ]);
      },
      () => {
        setNotifications(prev => [
          ...prev,
          {
            type: 'disabled',
            message: formatMessage(Messages.agentConversionPage_mappingErrorNotification, {
              oldCode: conversion.oldCode,
              newCode: conversion.newCode,
            }),
          },
        ]);
      }
    );
  }

  function enableConversion() {
    ServiceClient.enableAgentCodeConversionForRenewal(
      conversion.oldCode,
      conversion.newCode,
      () => {
        setAgentConversionsState(conversion, agentConversions, setAgentConversions);
        setNotifications(prev => [
          ...prev,
          {
            type: 'enabled',
            message: formatMessage(Messages.agentConversionPage_mappingEnabledNotification, {
              oldCode: conversion.oldCode,
              newCode: conversion.newCode,
            }),
          },
        ]);
      },
      () => {
        setNotifications(prev => [
          ...prev,
          {
            type: 'error',
            message: formatMessage(Messages.agentConversionPage_mappingErrorNotification, {
              oldCode: conversion.oldCode,
              newCode: conversion.newCode,
            }),
          },
        ]);
      }
    );
  }

  return (
    <>
      <ThreeDotIcon
        onClick={() => {
          setIsOpen(true);
        }}
      />

      <MenuList
        isOpen={isOpen}
        onOutsideClick={() => {
          setIsOpen(false);
        }}>
        <MenuListItem
          text={formatMessage(Messages.agentConversionPage_enable)}
          onClick={() => {
            enableConversion();
            setIsOpen(false);
          }}
          disabled={isConversionActive(conversion) || !conversion.newCode}
        />
        <MenuListItem
          text={formatMessage(Messages.agentConversionPage_disable)}
          onClick={() => {
            disableConversion();
            setIsOpen(false);
          }}
          disabled={!isConversionActive(conversion)}
        />
      </MenuList>
    </>
  );
};

export default ConversionTableMenu;
